const AlertError = ({children}) => (
    <div className="alert alert-danger" role="alert">
        {children}
    </div>
)

export default AlertError;
